export enum LocalUrls {
  deployment = '/assets/configuration/deployment.json',
  environment = '/assets/configuration/environment.json',
}
